import { Record } from 'immutable';

export default new Record({
  pending: true,
  error: undefined,
  data: undefined,
});
